import { render, staticRenderFns } from "./MyTarifs.vue?vue&type=template&id=4fb6b77a&"
import script from "./MyTarifs.vue?vue&type=script&lang=js&"
export * from "./MyTarifs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports